"use client";

import { useState } from "react";

// 사이트 자체 /favicon.ico 를 우선 사용(구글 s2 가 일부 기관 사이트에서 기본 글로브만 주는 문제 회피).
//   로드 실패 시 구글 s2(없으면 글로브) 로 폴백.
export function SiteFavicon({ primary, fallback }: { primary: string; fallback: string }) {
  const [src, setSrc] = useState(primary);
  return (
    // eslint-disable-next-line @next/next/no-img-element
    <img
      src={src}
      alt=""
      width={18}
      height={18}
      loading="lazy"
      onError={() => { if (src !== fallback) setSrc(fallback); }}
      style={{ flexShrink: 0, borderRadius: 4, display: "block" }}
    />
  );
}
